import _ from 'lodash/object'
import validation from './validation.js'
import conditionalFields from './conditionalFields.js'
import dropzoneConfig from './dropzoneConfig.js'
import redactorConfig from './redactorConfig.js'
import editableReferencesDeleter from './editableReferencesDeleter.js'
import xhrModule from '../xhrModule.js'
import general from '../general.js'

var formModule = {
	dropzoneInstantions: [],

	init: function (callback) {
		this.callback = callback
		this.dropzoneCallbacksCompletedInt = 0

		this.forms = document.querySelectorAll('form')

		this.objectsToPostInt = 0
		this.totalItemsToPost = []

		for (var i = this.forms.length - 1; i >= 0; i--) {
			// check if we need to submit with this module or not
			var moduleSubmit = this.forms[i].getAttribute('data-module')
			if (moduleSubmit === 'false') continue

			// add submit event
			var initialized = this.forms[i].classList.contains('form-initialized')
			if (!initialized) this.forms[i].addEventListener('submit', this.formSubmitHandler.bind(this))
			this.forms[i].classList.add('form-initialized')
		}

		this.initFormElements()
	},

	initFormElements: function () {
		for (var i = this.forms.length - 1; i >= 0; i--) {
			// check if there are any dropzones
			this.initDropzones(this.forms[i])

			// find conditional containers
			this.initConditionalFields(this.forms[i])

			// redactor init
			redactorConfig.init()

			if (i === 0) {
				document.querySelector('body').classList.remove('form-loading')
			}
		}
	},

	initDropzones: function (form) {
		var dropzones = form.querySelectorAll('.dropzone-previews')
		for (var dz = dropzones.length - 1; dz >= 0; dz--) {
			if (dropzones[dz].classList.contains('dropzone-initialized')) continue
			var dropzoneInst = dropzoneConfig(dropzones[dz])
			dropzoneInst.init()
			this.dropzoneInstantions.push(dropzoneInst)
		}
	},

	initConditionalFields: function (form) {
		var conditionalContainer = form.querySelectorAll('.conditional-container')
		for (var cc = conditionalContainer.length - 1; cc >= 0; cc--) {
			if (!conditionalContainer[cc].classList.contains('conditional-init-done')) {
				// main form without editable references
				conditionalFields(conditionalContainer[cc]).init()
			}

			// find editable references to split up the form and prevent a bottleneck
			const editableReferences = conditionalContainer[cc].querySelectorAll('.item.editable-reference-item:not(.conditional-init-done)')
			for (var i = editableReferences.length - 1; i >= 0; i--) {
				conditionalFields(editableReferences[i], true).init()
			}
		}
	},

	formSubmitHandler: function (e) {
		e.preventDefault()
		e.stopPropagation()

		var form = e.target
		this.form = form

		// check if this is a normal form or the password reset form
		var passwordResetForm = form.getAttribute('data-password-reset')
		if (passwordResetForm === 'true') {
			this.submitPasswordReset(form)
		} else {
			// The variable valid will return true of false.
			var valid = validation.validate(form, true, this.dropzoneInstantions)

			if (valid) {
				this.clearValuesForClosedConditionalFields(form)

				// add loading class to main container
				this.mainContainer = document.querySelector('#main')
				this.mainContainer.classList.add('loading')

				// first send all dropzone data before sending all other data
				for (var i = this.dropzoneInstantions.length - 1; i >= 0; i--) {
					this.dropzoneInstantions[i].sendData(this.dropzoneCallback.bind(this))
				}

				// when there are no dropzones we can just submit the normal form
				if (this.dropzoneInstantions.length === 0) this.deleteEditableReferences(form)
			}
		}
	},

	clearValuesForClosedConditionalFields: function (form) {
		this.editableReferencesToDelete = []
		// remove values from conditional hidden fields
		var conditionalHidden = form.querySelectorAll('.conditional-hidden')
		for (var ch = conditionalHidden.length - 1; ch >= 0; ch--) {
			// find hidden checkbox for radio and checkbox fields
			var inputs = conditionalHidden[ch].querySelectorAll('input:not([type=hidden]), select, textarea')
			var invisibleHiddenCheckbox = conditionalHidden[ch].querySelector('input.invisible-empty-checkbox')
			var invisibleHiddenRadio = conditionalHidden[ch].querySelector('input.invisible-empty-radio')

			// dropzone hidden input
			var hiddenFilesField = conditionalHidden[ch].querySelector('input.hidden-image-values')
			if (hiddenFilesField) hiddenFilesField.value = ''

			// find UUIDs for editable references we need to set to state 5
			var conditionalContainers = conditionalHidden[ch].querySelectorAll('[data-uuid]')
			for (var i = conditionalContainers.length - 1; i >= 0; i--) {
				var uuid = conditionalContainers[i].getAttribute('data-uuid')
				this.editableReferencesToDelete.push(uuid)
			}

			for (var ip = inputs.length - 1; ip >= 0; ip--) {
				this.resetValues(inputs[ip])
				if (ip === 0) {
					if (invisibleHiddenCheckbox) {
						invisibleHiddenCheckbox.checked = true
						invisibleHiddenCheckbox.value = ''
					}

					if (invisibleHiddenRadio) {
						invisibleHiddenRadio.checked = true
					}
				}
			}
		}
	},

	resetValues: function (input) {
		var type = input.type
		if (type === 'checkbox' || type === 'radio') {
			input.checked = false
			input.parentNode.classList.remove('checked')
		} else if (input.tagName === 'SELECT') {
			input.selectedIndex = 0
		} else {
			input.value = ''
		}
	},

	submitPasswordReset: function (form) {
		var valid = validation.validate(form)
		if (!valid) return

		// check if both values are the same
		var inputs = form.querySelectorAll('input:not([type=\'submit\'])')
		var errorMessage = form.querySelector('.error-message')
		if (inputs[0].value !== inputs[1].value) {
			// show error 'passwords are not identical'
			errorMessage.classList.remove('hidden')
			return
		} else {
			errorMessage.classList.add('hidden')
		}

		// save instances with new password
		var instances = form.getAttribute('data-uuid')
		instances = JSON.parse(instances)
		var totalLength = Object.keys(instances).length
		var instanceInt = 0

		var obj = {
			'entity': null,
			'uuid': null,
			'instance': []
		}

		for (var key in instances) {
			instanceInt++
			instances[key].data.password.value = inputs[0].value

			if (!obj.entity) {
				obj.entity = instances[key].entity.id
				obj.uuid = instances[key].uuid
			}

			var instance = {
				'id': instances[key].id,
				'market': instances[key].market.id,
				'state': instances[key].state,
				'properties': []
			}

			for (var prop in instances[key].data) {
				var value = instances[key].data[prop].value
				if (Array.isArray(value)) value = JSON.stringify(value)
				var propEl = {
					'id': instances[key].data[prop].id,
					'property': instances[key].data[prop].property.id || instances[key].data[prop].property,
					'value': value
				}

				instance.properties.push(propEl)
			}

			obj.instance.push(instance)

			if (instanceInt === totalLength) {
				// post instance
				var json = JSON.stringify(obj)
				var url = '/cms/api/instances/save'
				xhrModule.post(url, json, this.postPasswordCompleteHandler.bind(this))
			}
		}
	},

	postPasswordCompleteHandler: function (data) {
		this.callback()
	},

	sendForm: function () {
		// first send all dropzone data before sending all other data
		for (var i = this.dropzoneInstantions.length - 1; i >= 0; i--) {
			this.dropzoneInstantions[i].sendData(this.dropzoneCallback.bind(this))
		}
	},

	deleteEditableReferences: function (form) {
		editableReferencesDeleter.deleteItems(this.gatherFormData.bind(this), form)
	},

	gatherFormData: function (form) {
		var formData = new FormData(form)

		var object = {}
		formData.forEach((value, key) => {
			if (!Reflect.has(object, key)) {
				object[key] = value
				return
			}
			if (!Array.isArray(object[key])) {
				object[key] = [object[key]]
			}
			object[key].push(value)
		})

		var merged = {}
		for (var key in object) {
			_.set(merged, key, object[key])
		}

		this.prepareDataToBeSubmitted(merged)
	},

	prepareDataToBeSubmitted: function (merged) {
		// check the language state to define which instances need to be submitted
		// also get the market data from there
		var activeLangs = {}
		for (var lang in merged.lang) {
			if (lang === 'synced') continue
			if (merged.lang[lang].state) {
				activeLangs[lang] = {
					'state': merged.lang[lang].state,
					'market': merged.lang[lang].market
				}
			}
		}

		this.editableRefUUIDs = []
		// find all editable references and prepare their data as well
		if (merged['editableReferences']) {
			var editableReferencesData = merged['editableReferences']

			// we have to sort the editable references with the same entity together
			var sortedEditableReferences = {}
			for (var i = 0; i < editableReferencesData.length; i++) {
				if (editableReferencesData[i]) {
					var entityID = editableReferencesData[i].entity.id
					if (!sortedEditableReferences[entityID]) {
						sortedEditableReferences[entityID] = []
					}

					sortedEditableReferences[entityID].push(editableReferencesData[i])
				}

				if (i === editableReferencesData.length - 1) {
					for (var key in sortedEditableReferences) {
						var group = sortedEditableReferences[key]

						var uuidArray = []
						for (var editable in group) {
							var uuid = group[editable].uuid

							// if this UUID is found in the array with UUIDs to delete we can just skip this
							var index = this.editableReferencesToDelete.indexOf(uuid)
							if (index > -1) continue

							uuidArray.push(uuid)

							// add the value to the synced property
							if (!merged.lang['synced']) {
								merged.lang['synced'] = {}
							}

							if (!merged.lang['synced']['data']) {
								merged.lang['synced']['data'] = {}
							}

							// find the corresponding field name for this editable ref
							var entityName = group[editable].entity.name
							var entityProperties = JSON.parse(merged['entity-properties'])
							for (var prop in entityProperties) {
								if (entityProperties[prop].settings) {
									if (entityProperties[prop].settings.referenceId) {
										if (entityProperties[prop].settings.referenceId.value === group[editable].entity.id) {
											entityName = entityProperties[prop].name
										}
									}
								}
							}

							merged.lang['synced']['data'][entityName] = {
								'value': JSON.stringify(uuidArray)
							}

							// add active lang data for these editable references
							for (var activeLang in activeLangs) {
								group[editable].lang[activeLang]['state'] = 3
								group[editable].lang[activeLang]['market'] = activeLangs[activeLang].market
							}

							this.editableRefUUIDs.push(group[editable].uuid)
							this.formatInstancesData(group[editable])
						}
					}
				}
			}
		}

		// main form
		this.mainFormUUID = merged.uuid
		this.formatInstancesData(merged)
	},

	formatInstancesData: function (merged) {
		var entityProperties = merged['entity-properties']
		const propsIsJson = general.isJson(merged['entity-properties'])
		if (propsIsJson) {
			entityProperties = JSON.parse(merged['entity-properties'])
		}

		var instances = merged['instances']
		const instancesIsJson = general.isJson(merged['instances'])
		if (instancesIsJson) {
			instances = JSON.parse(merged['instances'])
		}

		// add synced fields to each language
		var syncedData = merged.lang.synced
		if (syncedData) {
			for (var fieldNames in syncedData.data) {
				for (var langKey in merged.lang) {
					if (!merged.lang[langKey].data) {
						merged.lang[langKey].data = {}
					}
					merged.lang[langKey].data[fieldNames] = syncedData.data[fieldNames]
				}
			}
		}

		// link property ID and name from entity
		for (var key0 in merged.lang) {
			var savedFields = merged.lang[key0]['data']

			var locale = null
			var instance = null
			if (merged.lang[key0].market) locale = merged.lang[key0].market.locale
			if (locale) {
				instance = this.getValueForThisLang(locale, instances)
			}

			for (var key1 in savedFields) {
				for (var key2 in entityProperties) {
					if (key2 === key1) {
						var id = 0
						if (instance) {
							if (instance.data[key2]) {
								id = instance.data[key2].id
							} else {
								id = 0
							}
						}

						var value = savedFields[key1].value
						if (Array.isArray(value)) {
							value = JSON.stringify(value)
						}

						savedFields[key1] = {
							'id': id,
							'property': {
								'id': entityProperties[key2].id,
								'name': entityProperties[key2].name
							},
							'value': value
						}
					}
				}
			}
		}

		var submittedLanguages = []

		for (var key in merged.lang) {
			if (key !== 'synced') {
				if (merged.lang[key].state) {
					submittedLanguages[key] = merged.lang[key]
				}
			}
		}

		// We need to check if there were any editable references that have been deleted and if so we need to add this field and post it with an empty array
		// This is only needed in case there are no editable references left to save because then the field will not be updated in the main form data

		// search for editable references
		for (var prop in entityProperties) {
			if (entityProperties[prop].settings) {
				if (entityProperties[prop].settings.type.value === 'Editable reference') {
					// check if this field exists in our data that we are posting
					var propName = entityProperties[prop].name
					// check in each submittedlang if the field is present or not
					// if not we can add it based on the data in the previous instances with an empty array
					for (var sl in submittedLanguages) {
						for (var inst in instances) {
							if (sl === instances[inst].market.locale && !submittedLanguages[sl].data[propName]) {
								if (instances[inst].data[propName]) {
									submittedLanguages[sl].data[propName] = instances[inst].data[propName]
									submittedLanguages[sl].data[propName].value = ''
									submittedLanguages[sl].data[propName].property = {
										id: parseInt(instances[inst].data[propName].property.id)
									}
								}
							}
						}
					}
				}
			}
		}

		// create final objects to be submitted
		var objectsToPost = []
		var objectLength = Object.keys(submittedLanguages).length
		var int = 0
		for (var key3 in submittedLanguages) {
			int++
			if (!submittedLanguages[key3].state) continue

			var data = submittedLanguages[key3].data

			var finalObject = {
				'uuid': merged.uuid,
				'id': submittedLanguages[key3].id,
				'state': submittedLanguages[key3].state,
				'entity': {
					'id': merged.entity.id,
					'name': merged.entity.name
				},
				'market': submittedLanguages[key3].market,
				'data': data
			}

			objectsToPost.push(finalObject)

			if (int === objectLength) this.postTheseObjects(objectsToPost)
		}
	},

	getValueForThisLang: function (locale, instances) {
		for (var key in instances) {
			if (instances[key].market.locale === locale) {
				return instances[key]
			}
		}
	},

	postTheseObjects: function (objectsToPost) {
		this.objectsToPostInt++
		this.totalItemsToPost.push(objectsToPost)

		var newFormatData = {}
		// +1 to account for the main form itself
		this.amountOfEditableReferences = document.querySelectorAll('.collapsed-view').length
		if (this.objectsToPostInt === this.amountOfEditableReferences + 1) {
			// find main form(s)
			for (var f = this.totalItemsToPost.length - 1; f >= 0; f--) {
				if (this.totalItemsToPost[f][0].uuid === this.mainFormUUID) {
					// transform data for new save endpoint
					newFormatData = {
						'entity': this.totalItemsToPost[f][0].entity.id,
						'uuid': this.totalItemsToPost[f][0].uuid,
						'instance': []
					}

					// add instance for each market
					for (var mf = 0; mf < this.totalItemsToPost[f].length; mf++) {
						var instance = {
							'id': this.totalItemsToPost[f][mf].id,
							'market': this.totalItemsToPost[f][mf].market.id,
							'state': this.totalItemsToPost[f][mf].state,
							'properties': []
						}

						// add all props
						for (var prop in this.totalItemsToPost[f][mf].data) {
							var value = this.totalItemsToPost[f][mf].data[prop].value
							var editableRefs = false
							var market = this.totalItemsToPost[f][mf].market.id

							// check if the value is an array of editable references
							if (general.isJson(value)) {
								var arr = JSON.parse(value)
								if (this.editableRefUUIDs.includes(arr[0])) editableRefs = true
							}

							var propEl = {
								'id': this.totalItemsToPost[f][mf].data[prop].id,
								'property': this.totalItemsToPost[f][mf].data[prop].property.id,
								'value': value
							}

							// add editable reference data if needed
							if (editableRefs) {
								propEl.value = []
								for (var er = 0; er < arr.length; er++) {
									// find data
									for (var tip = this.totalItemsToPost.length - 1; tip >= 0; tip--) {
										if (this.totalItemsToPost[tip][0].uuid === arr[er]) {
											// find correct lang
											for (var tipm = this.totalItemsToPost[tip].length - 1; tipm >= 0; tipm--) {
												if (this.totalItemsToPost[tip][tipm].market.id === market) {
													var uniqueRef = {
														'entity': this.totalItemsToPost[tip][tipm].entity.id,
														'uuid': this.totalItemsToPost[tip][tipm].uuid,
														'instance': [{
															'id': this.totalItemsToPost[tip][tipm].id,
															'market': this.totalItemsToPost[tip][tipm].market.id,
															'state': this.totalItemsToPost[tip][tipm].state,
															'properties': []
														}]
													}

													// add properties for editable ref
													for (var propRef in this.totalItemsToPost[tip][tipm].data) {
														uniqueRef.instance[0].properties.push({
															'id': this.totalItemsToPost[tip][tipm].data[propRef].id,
															'property': this.totalItemsToPost[tip][tipm].data[propRef].property.id,
															'value': this.totalItemsToPost[tip][tipm].data[propRef].value
														})
													}

													propEl.value.push(uniqueRef)
												}
											}
										}
									}
								}
							}

							instance.properties.push(propEl)
						}

						newFormatData.instance.push(instance)
					}
				}
			}

			this.mainContainer.classList.add('loading')
			var jsondata = JSON.stringify(newFormatData)
			// replace wrong registered trademark symbol with the correct one
			const searchRegExp = /®️/g
			const replaceWith = '®'
			jsondata = jsondata.replace(searchRegExp, replaceWith)

			var url = '/cms/api/instances/save'
			xhrModule.post(url, jsondata, this.postInstanceCompleteHandler.bind(this))
		}
	},

	postInstanceCompleteHandler: function (data) {
		if (data.data.error) {
			// check for errors
			if (data.data.status === 409) {
				// reset previous form data
				this.objectsToPostInt = 0
				this.totalItemsToPost = []

				this.mainContainer.classList.remove('loading')

				const slugFields = document.querySelectorAll('.slug-field')

				for (var i = slugFields.length - 1; i >= 0; i--) {
					if (slugFields[i].value === data.data.slug) {
						slugFields[i].parentNode.classList.add('error')
						slugFields[i].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
					}
				}
			}
		} else {
			// remove loading class from main container
			this.mainContainer.classList.remove('loading')
			this.callback()
		}
	},

	dropzoneCallback: function () {
		this.dropzoneCallbacksCompletedInt++

		if (this.dropzoneInstantions.length === this.dropzoneCallbacksCompletedInt) {
			this.dropzoneCallbacksCompletedInt = 0
			// after our dropzones are uploaded we can upload the rest of the form
			this.deleteEditableReferences(this.form)
		}
	},

	destroy: function () {
		// destroy redactor instances
		redactorConfig.destroy()

		// destroy dropzones
		for (var i = this.dropzoneInstantions.length - 1; i >= 0; i--) {
			this.dropzoneInstantions[i].destroy()
			this.dropzoneInstantions.splice(i, 1)
		}
	}
}

export default formModule
